"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const clsx_1 = __importDefault(require("clsx"));
const utils_1 = require("./utils");
const i18next_1 = require("i18next");
const LocationAutocomplete = ({ htmlId, error, onFocus, open, inputRef, value, setValue, setOpen, setCallFocus, autocompleteSessionToken, autocompleteService, timedOut, setTimedOut, predictions, setPredictions, activeIndex, setActiveIndex, customLocations, ignoreBlur, updateOption, location, setLocation, "aria-invalid": ariaInvalid, }) => {
    const onInputTimeout = (0, react_1.useRef)(null);
    const predictionCount = (0, react_1.useRef)(0);
    const shownPredictionCount = (0, react_1.useRef)(-1);
    const activeId = open ? `${htmlId}-${activeIndex}` : "";
    const doSearch = () => {
        var _a, _b, _c;
        if (inputRef.current) {
            const input = inputRef.current.value;
            const sessionToken = (_a = autocompleteSessionToken.current) !== null && _a !== void 0 ? _a : undefined;
            const offset = (_c = (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.selectionStart) !== null && _c !== void 0 ? _c : undefined;
            if (value !== input) {
                setValue(input);
            }
            if (onInputTimeout.current !== null) {
                window.clearTimeout(onInputTimeout.current);
            }
            const count = predictionCount.current++;
            if (input === "") {
                shownPredictionCount.current = count;
                const menuState = input !== "";
                if (open !== menuState) {
                    setOpen(menuState);
                    setCallFocus(false);
                }
                return;
            }
            onInputTimeout.current = window.setTimeout(() => {
                var _a;
                (_a = autocompleteService.current) === null || _a === void 0 ? void 0 : _a.getPlacePredictions({
                    input,
                    sessionToken,
                    offset,
                    componentRestrictions: { country: "CA" },
                    bounds: { north: 56.86, east: -74.34, south: 41.66, west: -95.16 },
                    types: ["geocode"],
                }, (predictions, status) => {
                    var _a;
                    if (count <= shownPredictionCount.current) {
                        return;
                    }
                    if (status === google.maps.places.PlacesServiceStatus.INVALID_REQUEST ||
                        status === google.maps.places.PlacesServiceStatus.OVER_QUERY_LIMIT ||
                        status === google.maps.places.PlacesServiceStatus.REQUEST_DENIED ||
                        status === google.maps.places.PlacesServiceStatus.UNKNOWN_ERROR) {
                        if (!timedOut)
                            setTimedOut(true);
                    }
                    else {
                        if (timedOut)
                            setTimedOut(false);
                    }
                    const locations = (_a = predictions === null || predictions === void 0 ? void 0 : predictions.filter((p) => p.description.indexOf("Toronto Premium") < 0)) !== null && _a !== void 0 ? _a : [];
                    const matchingCustomLocations = (0, utils_1.findMatchingCustomLocations)(input, customLocations);
                    const interleavedLocationsAndHomes = [];
                    // Start with two locations, interleave the rest...
                    if (locations[0] !== undefined) {
                        interleavedLocationsAndHomes.push(locations[0]);
                    }
                    for (let i = 1, j = 0; i < locations.length || j < matchingCustomLocations.length; i++, j++) {
                        if (locations[i] !== undefined) {
                            interleavedLocationsAndHomes.push(locations[i]);
                        }
                        if (matchingCustomLocations[j] !== undefined) {
                            interleavedLocationsAndHomes.push(matchingCustomLocations[j]);
                        }
                    }
                    setPredictions(interleavedLocationsAndHomes);
                    interleavedLocationsAndHomes.length === 0 && location && setLocation(undefined);
                    shownPredictionCount.current = count;
                    setActiveIndex(0);
                    const menuState = input !== "";
                    if (open !== menuState) {
                        setOpen(menuState);
                        setCallFocus(false);
                    }
                });
            }, 100);
        }
    };
    const onInputBlur = () => {
        if (ignoreBlur.current) {
            //inputRef.current?.focus();
            ignoreBlur.current = false;
            return;
        }
        setOpen(false);
        setCallFocus(false);
    };
    const onInputKeyDown = (event) => {
        const max = predictions.length - 1;
        const action = (0, utils_1.getActionFromKey)(event, open);
        switch (action) {
            case utils_1.MenuActions.Next:
            case utils_1.MenuActions.Last:
            case utils_1.MenuActions.First:
            case utils_1.MenuActions.Previous:
                event.preventDefault();
                return setActiveIndex((0, utils_1.getUpdatedIndex)(activeIndex, max, action));
            case utils_1.MenuActions.CloseSelect:
                event.preventDefault();
                return updateOption(activeIndex);
            case utils_1.MenuActions.Close:
                event.preventDefault();
                return setOpen(false);
            case utils_1.MenuActions.Open:
                return setOpen(true);
        }
    };
    return ((0, jsx_runtime_1.jsx)("input", { "aria-activedescendant": activeId, "aria-autocomplete": "list", "aria-controls": `${htmlId}-listbox`, "aria-expanded": open, "aria-haspopup": "listbox", "aria-label": (0, i18next_1.t)("searchBox.label"), "aria-invalid": ariaInvalid, "aria-describedby": `${htmlId}-hint-text`, autoComplete: "off", className: (0, clsx_1.default)("input autocomplete-input", { error }), id: `${htmlId}-input`, placeholder: "", ref: inputRef, role: "combobox", type: "text", value: value, required: true, onFocus: () => {
            if (onFocus)
                onFocus();
        }, onBlur: onInputBlur, onClick: (e) => {
            if (e.currentTarget.value !== "") {
                setOpen(true);
                if (onInputTimeout.current === null && predictions.length === 0) {
                    doSearch();
                }
            }
        }, onInput: doSearch, onKeyDown: onInputKeyDown }));
};
exports.default = LocationAutocomplete;
